module.exports = __webpack_public_path__ + "static/img/y_hgsw23.d912c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_hgsw23.png
// module id = TBY9
// module chunks = 73